import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.primary.main,
      padding: '2px',
      width: '24px',
      height: '24px',
      '& .MuiSvgIcon-root': { fontSize: 24 },
      '&.Mui-disabled': { color: '#D4D8E3' },
      '.Mui-error &': { color: theme.palette.error.contrastText },
      '&.MuiCheckbox-colorSecondary': {
        color: '#6948eb63',
      },
    }),
  },
};
